import React from 'react'
import { Heading } from '@scentregroup/ui'
import Link from '../link'
import { TermsModule } from '../../../types/content-page'
import style from './index.scss'

interface TableOfContentsProps {
  sections: TermsModule[]
  title?: string
}

const TableOfContents: React.FunctionComponent<TableOfContentsProps> = ({
  sections,
  title,
}) => (
  <div>
    <Heading type="small">{title}</Heading>
    <ul className={style.list}>
      {sections.map(section => (
        <li key={section.slug} className={style.listItem}>
          <Link title={section.title} href={`#${section.slug}`} target="_self">
            {section.title}
          </Link>
        </li>
      ))}
    </ul>
  </div>
)

TableOfContents.defaultProps = {
  sections: [],
  title: 'Table of Contents',
}

export default TableOfContents
